/** Clockwise degrees from 12 o'clock for slot `index` of `total`. */
export function orbitSlotDegreesFromTop(index, total) {
  return (index / total) * 360;
}

/** Same slot as radians in standard math coords (0° = east, 90° = south). */
export function orbitSlotRadians(index, total) {
  return ((orbitSlotDegreesFromTop(index, total) - 90) * Math.PI) / 180;
}

/**
 * Place an icon on a circle of radiusRem around (0,0), keeping it upright while
 * the parent rotator spins by `spinDegrees`.
 */
export function orbitIconTransform(index, total, radiusRem, spinDegrees = 0) {
  const angle = orbitSlotDegreesFromTop(index, total);
  return `rotate(${angle}deg) translateY(-${radiusRem}rem) rotate(${-angle - spinDegrees}deg)`;
}

/** Beam endpoint in SVG viewBox 0–100 with hub at (50, 50). */
export function orbitBeamPoint(index, total, orbitRadiusPercent) {
  const angleRad = orbitSlotRadians(index, total);
  return {
    x: 50 + Math.cos(angleRad) * orbitRadiusPercent,
    y: 50 + Math.sin(angleRad) * orbitRadiusPercent,
  };
}

/**
 * Orbit radius in rem: at least clears the hub card, expanded toward the zone edge
 * when there is room (fillRatio), capped so nodes stay inside the zone.
 */
export function computeOrbitRadiusRem(
  zoneSizeRem,
  cardSizeRem,
  nodeSizeRem,
  gapRem = 0.75,
  fillRatio = 0.88,
) {
  const zoneHalf = zoneSizeRem / 2;
  const cardHalf = cardSizeRem / 2;
  const nodeHalf = nodeSizeRem / 2;
  const minRadius = cardHalf + gapRem + nodeHalf;
  const maxRadius = zoneHalf - nodeHalf - 0.25;
  const expandedRadius = maxRadius * fillRatio;
  return Math.max(minRadius, Math.min(maxRadius, expandedRadius));
}

/** Convert rem radius to viewBox units for a square zone. */
export function orbitRadiusRemToViewBox(orbitRadiusRem, zoneSizeRem) {
  return (orbitRadiusRem / zoneSizeRem) * 100;
}
